module.exports = __webpack_public_path__ + "08_bob_gray.c481a817.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/08_bob_gray.png
// module id = +zR7
// module chunks = 0